import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { BRAND, buildWhatsAppLink } from "../data/brand";

export const EnquiryModal = ({ open, onClose, product }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", quantity: "", message: "" });

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const lines = [
      `Hi ${BRAND.name}, I would like to enquire`,
      product ? `about *${product.name}* (${product.categoryLabel}).` : "about your incense products.",
      "",
      `Name: ${form.name || "-"}`,
      `Phone: ${form.phone || "-"}`,
      `Email: ${form.email || "-"}`,
      `Quantity / Requirement: ${form.quantity || "-"}`,
      form.message ? `Message: ${form.message}` : "",
    ].filter(Boolean);
    window.open(buildWhatsAppLink(lines.join("\n")), "_blank");
    onClose();
  };

  const field = "w-full bg-transparent border-b border-charcoal/25 focus:border-gold outline-none py-3 text-charcoal placeholder:text-charcoal/40 transition-colors duration-300";

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[70] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="enquiry-modal"
        >
          <div className="absolute inset-0 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.98 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="relative w-full max-w-lg bg-ivory border border-gold/40 p-8 md:p-10 max-h-[92vh] overflow-y-auto"
          >
            <button onClick={onClose} data-testid="enquiry-close" className="absolute top-5 right-5 text-charcoal/60 hover:text-charcoal" aria-label="Close">
              <X size={22} />
            </button>

            <p className="text-xs tracking-[0.3em] text-gold mb-3">ENQUIRE NOW</p>
            <h3 className="font-serif text-4xl leading-none mb-2">
              {product ? `Interested in ${product.name}?` : "Talk to SK Fragrances"}
            </h3>
            {product && (
              <p className="text-sm text-charcoal/60 mb-6">{product.categoryLabel} · {product.descriptor}</p>
            )}

            <form onSubmit={submit} className="mt-4 space-y-5">
              <input required data-testid="enquiry-name" className={field} placeholder="Your Name" value={form.name} onChange={set("name")} />
              <input required data-testid="enquiry-phone" className={field} placeholder="Phone Number" value={form.phone} onChange={set("phone")} />
              <input type="email" data-testid="enquiry-email" className={field} placeholder="Email (optional)" value={form.email} onChange={set("email")} />
              <input data-testid="enquiry-quantity" className={field} placeholder="Quantity / Requirement" value={form.quantity} onChange={set("quantity")} />
              <textarea data-testid="enquiry-message" rows={3} className={`${field} resize-none`} placeholder="Message (optional)" value={form.message} onChange={set("message")} />

              <button
                type="submit"
                data-testid="enquiry-submit"
                className="btn-line w-full bg-charcoal text-ivory py-4 text-sm tracking-[0.2em] hover:text-charcoal mt-2"
              >
                SEND ENQUIRY →
              </button>
              <p className="text-[11px] text-center text-charcoal/45">Opens WhatsApp with your enquiry pre-filled.</p>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
